import { observer } from "mobx-react";
import React, { FunctionComponent } from "react";
import { useStore } from "../../../../../../utils/useStore";
import AcxToggleButton from "../../../../../UI/AcxToggleButton";
import { ReportEditorStore } from "../../../Stores/ReportEditorStore";
import { QueryFilterOptions } from "../Editor";

interface OwnProps {}

type Props = OwnProps;

const QueryFilterSection: FunctionComponent<Props> = observer((props) => {
    const store = useStore(ReportEditorStore);

    return (
        <>
            <AcxToggleButton
                id={"queryFilterOptions"}
                items={[
                    {
                        element: `Include All ${
                            store.currentReportDataView?.displayName ?? ""
                        } Records`,
                        value: QueryFilterOptions.None,
                    },
                    {
                        element: `Filter These ${
                            store.currentReportDataView?.displayName ?? ""
                        } Records..`,
                        value: QueryFilterOptions.Custom,
                    },
                ]}
                disabled={!Boolean(store.currentReportDataView)}
                defaultValue={store.queryFilterOption}
                onChange={store.setQueryFilterOption}
                exclusive
            />
        </>
    );
});

export default QueryFilterSection;
